import { el, setChildren, list } from 'redom';

import activityTypes from '../constants/activity-types';
import activityStatuses from '../constants/activity-statuses';

import SuggestionsDisplay from './suggestions-display';

class Dots {

  constructor() {
    this.el = el('.message-typing-indicator-dot');
  }

}

class Wave {

  constructor() {
    this.wave = list('#message-typing-indicator-container', Dots, 'id', {});
    this.wave.update([{ id: 1 }, { id: 2 }, { id: 3 }]);
    this.el = this.wave.el;
  }

}

class TypingActivity {

  constructor(activity) {

    this.profilePicture = el('label.profile-picture', {
      style: {
        backgroundImage: `url(${activity.metadata.sender.profilePicture.url})`
      }
    });

    this.el = el('#typing-activity-main', [
      new Wave(),
      this.profilePicture
    ]);

  }

}

class ThinkingActivity {

  constructor(activity) {

    this.profilePicture = el('label.profile-picture', {
      style: {
        backgroundImage: `url(${activity.metadata.sender.profilePicture.url})`
      }
    });

    this.el = el('#typing-activity-main', [
      new Wave(),
      this.profilePicture
    ]);

  }

}

class GenericActivity {

  constructor(activity) {

    let message = `Using ${activity.type}`;
    if (message.toLowerCase().indexOf('skill') === -1) {
      message = `${message} skill`;
    }

    if (activity.status === activityStatuses.COMPLETED) {
      message = `${activity.type} completed`;
    } else if (activity.status === activityStatuses.PROCESSING) {
      message = `${activity.type} processing results...`;
    } else if (activity.status === activityStatuses.STARTED) {
      message = `${message}...`;
    }

    if (activity.formatted === true) {
      message = `${activity.skill} ${activity.type.toLowerCase()}`;
    }

    this.el = el('#generic-activity-main', [
      new Wave(),
      el('label.sub-text', message)
    ]);

  }

}

class ConversationActivityDisplay {

  constructor(configuration) {

    this.internetPhone = configuration.internetPhone;
    this.conversation = null;
    this.activity = null;
    this.clearTimerReference = null;
    this.suggestionsDisplay = new SuggestionsDisplay(configuration);

    this.container = el('#conversation-activity-container');

    this.activityContainer = el('#conversation-activity-display-main');
    this.suggestionsContainer = el('#conversation-suggestions-container', []);

    this.el = el('#conversation-activity-and-suggestions-main', [
      this.activityContainer,
      this.suggestionsContainer
    ]);

  }

  renderActivity() {

    if (this.activity.type === activityTypes.TYPING) {
      if (this.activity.status === activityStatuses.STARTED) {
        return new TypingActivity(this.activity);
      } else if (this.activity.status === activityStatuses.PROCESSING) {
        return new ThinkingActivity(this.activity);
      } else {
        return null;
      }
    } else if (this.activity.type !== activityTypes.RESET) {
      return new GenericActivity(this.activity);
    }

  }

  tryDisplayActivity(data) {

    if (this.activity !== null) {
      if (this.activity.createdAt > data.activity.createdAt) {
        return;
      }
    }

    this.activity = data.activity;

    const view = this.renderActivity();

    clearTimeout(this.clearTimerReference);

    const views = [];

    if (view !== null) {
      views.push(view);
      setChildren(this.container, view);

      if (typeof data.activity.timeout === 'number') {
        this.clearTimerReference = setTimeout(() => this.hideActivity(), data.activity.timeout);
      }

      setChildren(this.activityContainer, [
        this.container
      ]);
    } else {
      this.hideActivity();
    }

  }

  hideActivity() {

    this.activity = null;

    setChildren(this.container, []);
    setChildren(this.activityContainer, []);

  }

  tryHideActivity(message) {

    if (this.activity?.metadata.messageId !== message.channelMetadata.messageId.external) {
      return;
    }

    this.hideActivity();

  }

  updateSuggestions(conversation) {

    this.conversation = conversation;

    this.suggestionsDisplay.update(this.conversation);

  }

  hideSuggestions() {

    setChildren(this.suggestionsContainer, []);

  }

  showSuggestions() {

    this.update(this.conversation);

  }

  update(conversation) {

    this.conversation = conversation;

    const children = [];

    if (this.conversation.suggestion?.options?.length > 0 && this.conversation.autoReply === 'AI_DRAFT' && this.conversation.suggestion.for === this.internetPhone.getLatestMessage()?._id) {
      this.suggestionsDisplay.update(this.conversation);
      children.push(this.suggestionsDisplay);
    }

    setChildren(this.suggestionsContainer, children);

  }

  tryShowSuggestions() {

    this.update(this.conversation);

  }

}

export default ConversationActivityDisplay;